//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import AMap from "AMap";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      // 地图start
      activeType: 0, //当前搜索类别的下标
      types: [
        "200300", //卫生间
        "150900", //停车场
        "050000", //美食
        //  "050000|050100|050101|050102|050103|050104|050105|050106|050107|050108|050109|050110|050111|050112|050113|050114|050115|050116|050117|050118|050119|050120|050121|050122|050123|050200|050201|050202|050203|050204|050205|050206|050207|050208|050209|050210|050211|050212|050213|050214|050215|050216|050217|050300|050301|050302|050303|050304|050305|050306|050307|050308|050309|050310|050311|050400|050500|050501|050502|050503|050504|050600|050700|050800|050900", //美食
        "100000", //住宿
      ], //搜索的类别
      curMarkers: [], //当前点的合集
      mapObj: null, //地图实例
      leLayer: null, //瓦片实例
      mapMaxZoom: 19, //地图最大层级
      mapMinZoom: 13, //地图最小层级
      geolocation: null, //定位组件
      isLocation: false, //是否展示当前定位了
      locationMarker: null, //当前定位marker点
      toiletPois: null, //厕所点集合
      walk: null, //线路规划
      walkIdx: -1, //线路规划中的poi点的下标
      // 地图end
    };
  },
  //监听属性 类似于data概念
  computed: {
    // toiletPois: function() {}
  },
  //监控data中的数据变化
  watch: {
    // 如果 `question` 发生改变，这个函数就会运行
    // toiletPois: function(newV, oldV) {
    //     console.log('变化咯。。。。。。。。。')
    // }
  },
  //方法集合
  methods: {
    //   地图初始化
    initMap() {
      let that = this;
      // 创建地图实例
      that.mapObj = new AMap.Map("container", {
        view: new AMap.View2D({
          //创建地图二维视口
          // center: new AMap.LngLat(
          //   sessionStorage.getItem("lng"),
          //   sessionStorage.getItem("lat")
          // ),
          zoom: 16, //设置地图缩放级别
          rotation: 0, //设置地图旋转角度
        }),
        resizeEnable: true,
        zooms: [that.mapMinZoom, that.mapMaxZoom],
        features: ["bg", "road", "building"],
        lang: "zh_cn", //设置地图语言类型，默认：中文简体
      });
      // 瓦片加载
      that.leLayer = new AMap.TileLayer({
        // 图块取图地址,加了s=1就是下沙景区限制
        tileUrl:
          "https://daoyou.worldmaipu.com" +
          "/api/v1/tile!GetScenicTile.action?x=[x]&z=[z]&y=[y]&hid=" +
          that.hid,
        // 'https://pic2.worldmaipu.com/api/v1/tile!GetBlodTile.action?x=[x]&z=[z]&y=[y]',
        // 'https://pic2.worldmaipu.com/api/v1/tile!GetBlodTile.action?x=[x]&z=[z]&y=[y]&hid=',
        zIndex: 2,
      });
      //   that.leLayer.setMap(that.mapObj);
      // 缩放组件
      // that.mapObj.plugin(["AMap.ToolBar"], function() {
      //   that.mapObj.addControl(
      //     new AMap.ToolBar({
      //       position: "RB",
      //       //locate:true
      //       liteStyle: true,
      //       offset: new AMap.Pixel(10, 100)
      //     })
      //   );
      // });

      // if (that.GLOBAL.isWx) {
      //   // 微信环境
      //   setTimeout(() => {
      //     that.wxGetLocationOnce();
      //   }, 600);
      // } else {
      //   // 普通浏览器环境
      //   that.geolocation = new qq.maps.Geolocation(
      //     "3HQBZ-TEX3X-NJF43-73EDL-RUD7H-NVBJM",
      //     "myweb"
      //   );
      //   // 初始默认持续获取当前定位
      //   that.watchCurPosition();
      // }
       that.geolocation = new qq.maps.Geolocation(
          "3HQBZ-TEX3X-NJF43-73EDL-RUD7H-NVBJM",
          "myweb"
        );
        // 初始默认持续获取当前定位
        that.watchCurPosition();
    },
    // 持续获取当前定位
    watchCurPosition() {
      console.log("on");
      var that = this;
      that.geolocation.watchPosition(showPosition);
      function showPosition(position) {
        that.clearWatchCurPosition();
        console.log(position);
        let lnglat = new AMap.LngLat(position.lng, position.lat);
        that.mapObj.setCenter(lnglat);
        sessionStorage.setItem("lng", position.lng);
        sessionStorage.setItem("lat", position.lat);
        console.log(lnglat);
        if (that.isLocation) {
          that.locationMarker.setPosition(lnglat);
        } else {
          that.isLocation = true;
          that.locationMarker = new AMap.Marker({
            position: lnglat,
            offset: new AMap.Pixel(-8, -16),
            content: "<div class='curMarker'></div>",
            zIndex: 101,
          });
          that.mapObj.add(that.locationMarker);
        }
        that.searchToilet(position.lat, position.lng, that.activeType);
      }
    },
    // 微信中获取一次定位
    wxGetLocationOnce() {
      let that = this;
      this.$wechat.getLocation({
        type: "gcj02", // 默认为 wgs84 返回 gps 坐标，gcj02 返回可用于 wx.openLocation 的坐标
        success: function (res) {
          // success
          console.log(res);
          let lat = res.latitude;
          let lng = res.longitude;
          // let lat = 36.195606;
          // let lng = 113.589566;
          let lnglat = new AMap.LngLat(lng, lat);
          sessionStorage.setItem("lng", lng);
          sessionStorage.setItem("lat", lat);
          if (that.isLocation) {
            that.locationMarker.setPosition(lnglat);
          } else {
            that.isLocation = true;
            that.locationMarker = new AMap.Marker({
              position: lnglat,
              offset: new AMap.Pixel(-8, -16),
              content: "<div class='curMarker'></div>",
              zIndex: 101,
            });
            that.mapObj.add(that.locationMarker);
          }
          that.searchToilet(lat, lng, that.activeType);
        },
        fail: function () {
          // fail
        },
        complete: function () {
          // complete
        },
      });
    },
    // 停止获取当前定位
    clearWatchCurPosition() {
      console.log("off");
      this.geolocation.clearWatch();
      // this.mapObj.remove(this.locationMarker);
      // this.isLocation = false;
      // this.locationMarker = null;
    },

    //   搜索厕所poi
    searchToilet(lat, lng, typeIndex) {
      let that = this;
      if (that.curMarkers.length > 0) {
        that.mapObj.remove(that.curMarkers);
        that.curMarkers = [];
      }
      let searchTypes;

      searchTypes = that.types[typeIndex];
      console.log(searchTypes);

      $.getJSON(
        "https://restapi.amap.com/v3/place/around",
        {
          key: "c2526cf60981aa9faf0d2a8bab1b67bc",
          radius: 30000,
          types: that.types[typeIndex],
          location: lng + "," + lat,
          output: "JSON",
        },
        function (res) {
          console.log(res);
          that.toiletPois = res.pois;
          that.setToiletPois(that.toiletPois, that.activeType);
          that.$nextTick(function () {
            document.getElementById("toiletBox").scrollTop = 0;
          });
        }
      );
    },
    changType(i) {
      if (this.activeType == i) {
        return;
      } else {
        if (this.walk) {
          this.walk.clear();
        }
        this.walkIdx = -1;
        this.searchToilet(
          sessionStorage.getItem("lat"),
          sessionStorage.getItem("lng"),
          i
        );
        this.activeType = i;
      }
    },
    setToiletPois(arr, type) {
      let that = this;
      let contentHtml = "";
      switch (parseInt(type)) {
        case 0:
          contentHtml = "<div class='search-toilet'></div>";
          break;
        case 1:
          contentHtml = "<div class='search-park'></div>";

          break;
        case 2:
          contentHtml = "<div class='gas-station'></div>";

          break;
        case 3:
          contentHtml = "<div class='search-stop'></div>";
          break;
        case 4:
          contentHtml = "<div class='search-hospital'></div>";
          break;
      }
      for (let i in arr) {
        let marker = new AMap.Marker({
          // map: that.mapObj,
          position: new AMap.LngLat(
            arr[i].location.split(",")[0],
            arr[i].location.split(",")[1]
          ),
          offset: new AMap.Pixel(-16, -32),
          content: contentHtml,
          extData: {
            index: i,
          },
        });
        // that.mapObj.add(marker);
        AMap.event.addListener(marker, "click", function (e) {
          that.walkIdx = e.target.getExtData().index;
          let lat = e.target.getPosition().lat;
          let lng = e.target.getPosition().lng;
          AMap.service("AMap.Walking", function () {
            if (that.walk) {
              that.walk.clear();
            }
            that.walk = new AMap.Walking({
              map: that.mapObj,
              //用于显示路线指引信息的Div容器的id或Div元素
              //panel: "panel"
            });
            // 根据起终点经纬度规划驾车导航路线
            that.walk.search(
              [sessionStorage.getItem("lng"), sessionStorage.getItem("lat")],
              [lng, lat],
              function (status, result) {
                // console.log(result);
                if (status === "complete" && result.info === "OK") {
                  that.mapObj.setCenter([
                    sessionStorage.getItem("lng"),
                    sessionStorage.getItem("lat"),
                  ]);
                }
              }
            );
          });
          console.log(
            document.getElementsByClassName("toilet-item")[that.walkIdx]
              .offsetTop
          );
          // 规划中的厕所点的对应dom滚动到顶部
          document.getElementById(
            "toiletBox"
          ).scrollTop = document.getElementsByClassName("toilet-item")[
            that.walkIdx
          ].offsetTop;
        });
        that.curMarkers.push(marker);
      }
      that.mapObj.add(that.curMarkers);
      that.mapObj.setFitView();
    },
    // 规划线路 和点位点击事件相同
    drawWlak(item, i) {
      let that = this;
      that.walkIdx = i;
      let lat = item.location.split(",")[1];
      let lng = item.location.split(",")[0];
      AMap.service("AMap.Walking", function () {
        if (that.walk) {
          that.walk.clear();
        }
        that.walk = new AMap.Walking({
          map: that.mapObj,
          //用于显示路线指引信息的Div容器的id或Div元素
          //panel: "panel"
        });
        // 根据起终点经纬度规划驾车导航路线
        that.walk.search(
          [sessionStorage.getItem("lng"), sessionStorage.getItem("lat")],
          [lng, lat],
          function (status, result) {
            // console.log(result);
            if (status === "complete" && result.info === "OK") {
              that.mapObj.setCenter([
                sessionStorage.getItem("lng"),
                sessionStorage.getItem("lat"),
              ]);
            }
          }
        );
      });
      console.log(
        document.getElementsByClassName("toilet-item")[that.walkIdx].offsetTop
      );
      // 规划中的厕所点的对应dom滚动到顶部
      document.getElementById(
        "toiletBox"
      ).scrollTop = document.getElementsByClassName("toilet-item")[
        that.walkIdx
      ].offsetTop;
    },
    nav(name, lat, lng) {
      this.commonFun.openLocation(
        name,
        sessionStorage.getItem("lat"),
        sessionStorage.getItem("lng"),
        lat,
        lng
      );
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.initMap();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};



// WEBPACK FOOTER //
// ./src/pages/Near/Near.vue